<template>
    <div>
        <!-- <p>點擊白底或方框開始掃描:</p> -->
        <!-- <p>merchant_id: {{ merchant_id }}</p> -->
        <!-- <input type="text" v-model="scanned_ticket"> -->
        <!-- <div>{{ scanned_list }}</div> -->
    </div>
</template>
<script>
  export default {
    props: [
        "scanner",
        "customFunction",
    ],
    data: () => ({
      loading: false,
    }),
    computed:{
        // checkListener: function(){
        //     return this.$barcodeScanner.hasListener()
        // }
    },
    created () {
      const eventBus = this.$barcodeScanner.init(this.onBarcodeScanned, { eventBus: true })
      // Add barcode scan listener and pass the callback function
      if (eventBus) {
        eventBus.$on('start', () => { 
            this.loading = true
        })
        eventBus.$on('finish', () => { 
            this.loading = false 
        })
      }
    //   this.$barcodeScanner.init(this.onBarcodeScanned)

    },
    destroyed () {
      // Remove listener when component is destroyed
      // this.$barcodeScanner.destroy()
    },
    mounted(){
      this.init();
    },
    methods: {
      checkInput(input){
        let str = input;
        for(let i = 0; i < str.length; i++){
          if(str[i].match(/[\u0000-\u00ff]/)){
            console.log("半形");
          }
          else if(str[i].match(/[\uff00-\uffff]/)){
            console.log("全形");
            this.$bus.fnShowInfo("請確認輸入法為英文半形")
            return false
          }
          else{
            console.log("其他")
            this.$bus.fnShowInfo("請確認輸入法為英文半形")
            return false
            // console.log(str[i])
          }
        }
      },
      init(){
      this.loading = false;
      },
      // Create callback function to receive barcode when the scanner is already done
      onBarcodeScanned (barcode) {
        // console.log(barcode)

        // ticked_id regrex check
        if(this.checkInput(barcode) == false){
          return
        }
        this.customFunction(barcode)
        // console.log(barcode);          
        // do something...
      },
      // Reset to the last barcode before hitting enter (whatever anything in the input box)
      resetBarcode () {
        let barcode = this.$barcodeScanner.getPreviousCode()
        // return barcode
        console.log("last",barcode)
        // do something..
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>